// import { ExceptionTypeEnum } from '@ordersnproducts/modules/shared/models/exception-type.enum';
import { Observable } from 'rxjs';
import { mergeMap, retryWhen } from 'rxjs/operators';

export const logException = () => (source: Observable<any>) => {
  return source.pipe(
    retryWhen((errors: Observable<any>) =>
      errors.pipe(
        mergeMap(error => {
          // appInsights.trackException(error.message);
          // appInsights.trackTrace(`${ExceptionTypeEnum.API} ${error.message}`);
          return source;
        }),
      ),
    ),
  );
};
